import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useUXPContext } from '@core/context/useUXPContext';
import { useExportActivity } from '@hooks/exportEngine';
import NotificationBlock from '@helper/NotificationBlock';
import IconButton from '@widget/buttons/IconButton';
// Shown while a CSV export is running. The export is fed by this tab's JS, so a
// reload/close cancels it (a beforeunload guard in exportEngine also warns).
// Driven purely by the in-memory engine state, so it clears on a page reload.
// The close button hides the banner without cancelling the export.
export const ExportInProgressBanner = () => {
    const context = useUXPContext();
    const active = useExportActivity();
    const [dismissed, setDismissed] = useState(new Set());
    // keep only currently-active ids dismissed, so a new export re-shows the banner
    useEffect(() => {
        setDismissed(prev => {
            const next = new Set(active.filter(a => prev.has(a.id)).map(a => a.id));
            return next.size === prev.size ? prev : next;
        });
    }, [active]);
    if (!active.some(a => !dismissed.has(a.id)))
        return null;
    return (_jsx(NotificationBlock, { variant: "warning", mode: "compact", class: "uxpcore_notification--top-banner", message: context.$L('uxp-core.export.in-progress-no-refresh'), action: _jsx(IconButton, { type: "close", size: "small", onClick: () => setDismissed(new Set(active.map(a => a.id))) }) }));
};
